import React, { Component } from "react";
import EditableTable from "@components/Table/EditableTable";
import { connect } from "react-redux";
import { api } from "@redux/api";
import { FunctionalFormColumns, functionformProps } from "@containers/management/FunctionalForm/FunctionalFormColumns";
import { FunctionalFormFormFields } from "@containers/management/FunctionalForm/FunctionalFormFields";
import { useAuth, AUTH_LEVEL } from "@/hooks/use-auth";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const CREATE_FORM_PATH = "/admin/create-form";

class FunctionalForm extends Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.state = {
      data: [],
      name: "",
      isLoading: false,
      query: null,
      tableRef: null,
    };
  }

  handleCreateFunctionalForm = (body) => {
    return api.createForm(body).then((response) => response.data).catch((error) => error);
  };

  handleDeleteFunctionalForm = (id) => {
    return api.deleteForm(id).then((response) => response.data).catch((error) => error);
  };

  handleBulkDelete = (body) => {
    let payload;
    if (Array.isArray(body)) {
      payload = {
        ids: body.map((r) => (r != null && typeof r === "object" ? r.id : r)).filter((id) => id != null),
      };
    } else {
      payload = body;
    }
    return api.bulkDeleteForms(payload).then((response) => response.data).catch((error) => error);
  };

  handOnlineSave = (key, row) => {
    return api.editForm(key, row).then((response) => response).catch((error) => error);
  };

  handleFilter = (query) => {
    this.setState({
      isLoading: true,
    });
    return api
      .filterForms(query || "")
      .then((response) => {
        const dataSource = response.data.results;
        return {
          data: dataSource,
          success: true,
          total: response.data.count,
        };
      })
      .catch((error) => error);
  };

  getFunctionalForm = (data) => {
    this.setState({
      isLoading: false,
      data,
    });
  };

  refresh = (needRequest) => {
    return this.tableRef?.current?.refresh(needRequest);
  };

  renderSearches = () => {};
  gettableRef = (tableRef) => {
    console.log("tableRef", tableRef);
    this.setState({
      tableRef,
    });
  };

  render() {
    return (
      <div>
        <EditableTable
          ref={this.tableRef}
          columns={FunctionalFormColumns}
          data={this.state.data}
          columnProps={functionformProps}
          formFields={FunctionalFormFormFields(this.state.tableRef)}
          getRecord={this.getFunctionalForm}
          createRecords={this.handleCreateFunctionalForm}
          deleteRecord={this.handleDeleteFunctionalForm}
          bulkInsert={this.handleBulkInsert}
          bulkDelete={this.handleBulkDelete}
          handOnlineSave={this.handOnlineSave}
          handleFilter={this.handleFilter}
          postComment={this.handlePostComment}
          renderFilter={this.renderFilter}
          hide_search={true}
          isRowClickable={false}
          isRelated={false}
          isAttachments={false}
          setFilters={this.setFilters}
          filterDescription={this.state.filterDescription}
          getFormRef={this.gettableRef}
          hide_imports={true}
          formClassName={"flex-form"}
          hid_new={!this.props.canWrite}
          canDelete={this.props.canFullAccess}
          new_text={"Create Form"}
          onNew={() => this.props.navigate(CREATE_FORM_PATH)}
          onDoubleClick={(record) => this.props.navigateToAdminFormDetail(record.id)}
        />
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

const withHooks = (Component) => {
  const NewComponent = (props) => {
    const canWrite = useAuth("functionform", AUTH_LEVEL.WRITE);
    const canFullAccess = useAuth("functionform", AUTH_LEVEL.FULL_ACCESS);
    const { navigateToAdminFormDetail, navigate } = useSmartNavigate();
    return (
      <Component
        {...props}
        canWrite={canWrite}
        canFullAccess={canFullAccess}
        navigateToAdminFormDetail={navigateToAdminFormDetail}
        navigate={navigate}
      />
    );
  };
  return NewComponent;
};

export default withHooks(
  connect(mapStateToProps, mapDispatchToProps)(FunctionalForm)
);
